import React, { memo, useEffect } from "react";
import { isEmpty } from "lodash";
import { getCoverTint } from "../../core/utils/helpers/general";
import { Work } from "../../core/utils/types/entities";
import CardListItem from "./card-list-item/card-list-item";
import CardListItemSkeleton from "./card-list-item/card-list-item-skeleton";
import MaterialListItem from "./MaterialListItem";

export interface SearchResultListProps {
  resultItems: Work[];
  page: number;
  pageSize: number;
}

const SearchResultList: React.FC<SearchResultListProps> = ({
  resultItems,
  page,
  pageSize
}) => {
  // console.log(resultItems);
  const worksAreLoaded = !isEmpty(resultItems);
  const lastItemRef = React.useRef<HTMLLIElement>(null);

  useEffect(() => {
    if (page > 0 && lastItemRef.current) {
      lastItemRef.current.focus();
    }
  }, [page, resultItems]);

  return (
    <ul className="content-list" data-cy="search-result-list">
      {/*
          Show skeleton search result items if no data is available yet.
          We'll show 5 items which should cover most screens.
        */}
      {!worksAreLoaded &&
        [...Array(5)].map((u,i) => (
          <li key={i} className="content-list__item">
            <CardListItemSkeleton />
          </li>
        ))}
      {worksAreLoaded &&
        resultItems.map((item, i) => {
          const isFirstNewItem = i === page * pageSize;
          return (
            <div
              key={item.workId}
            >
            <MaterialListItem
              className="search-result-content-list__item"
              key={item.workId}
              ref={isFirstNewItem ? lastItemRef : null}
              >
              <CardListItem
                item={item}
                coverTint={getCoverTint(i)}
                resultNumber={i + 1}
                />
            </MaterialListItem>

            {/* The manifestation list in the adv. search result for classical music */}
            <p className="search-result-manifestation-list-heading">
            {item.genreAndForm.includes("klassiske symfonier") && <>Indspilninger</>}
            </p>
            <ul className="search-result-manifestation-list">
              {item.genreAndForm.includes("klassiske symfonier") &&
                item.manifestations.all.map((manifest, i) => {
                  return (
                    <li key={i} className="stacked-manifestations arrow__hover--right-small">
                      <a 
                        className="search-result-manifestation-link" 
                        href={"/manifestation/" + manifest.pid}
                      ><>{manifest.titles.standard || manifest.titles.main}</>
                      <><svg width="61" height="9" viewBox="0 0 61 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path className="arrow__body" d="M60 4.5H0" stroke="black"></path><path className="arrow__head" d="M60.3537 4.85355C60.5489 4.65829 60.5489 4.34171 60.3537 4.14645L57.1717 0.96447C56.9764 0.769208 56.6598 0.769208 56.4646 0.96447C56.2693 1.15973 56.2693 1.47631 56.4646 1.67157L59.293 4.5L56.4646 7.32843C56.2693 7.52369 56.2693 7.84027 56.4646 8.03553C56.6598 8.2308 56.9764 8.2308 57.1717 8.03553L60.3537 4.85355ZM60.0001 4H57.0001V5H60.0001V4Z" fill="black"></path></svg>
                      </>
                      </a>
                    </li>
                  )
                })}
              </ul>
            </div>
          );
        })}
    </ul>
  );
};

export default memo(SearchResultList);
